import React from 'react';
import {connect} from "react-redux";
import {Button, ButtonGroup, Card, CardBody} from "reactstrap";
import {toast} from "react-toastify";

import APIForm2 from "../../Components/APIForm2";
import PageTitle from "../../Layout/AppMain/PageTitle";
import {requestPermission, messaging} from "../../init-firebase-cloud-messaging";
import {revokeFirebaseToken} from "../../thunks/Notifications";
import {isMobileDevice} from "../../index";
import {renderErrorsAsHTML} from "../../Components/utils";
import {useTranslation} from "react-i18next";
import AppWrapper from '../../Layout/AppWrapper';


const LiveChat = (
    {
        activeShop,
        firebaseTokenCancelTokenSource,
        firebaseToken,
        firebaseTokenErrors,
        revokeFirebaseToken,
    }
) => {
    const {t, i18n} = useTranslation();
    const isWebpushSupported = messaging && ('Notification' in window) && !(isMobileDevice());

    return <AppWrapper>
                <div className="app-main__inner livechat">
                    <PageTitle
                        heading={t('settings.live_chat.page.title', 'Operator chat settings')}
                        enablePageTitleCreationButton={false}
                    />
                    <Card
                        className="main-card mb-3"
                        onKeyDown={(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                        }}
                    >
                        <CardBody>
                            <APIForm2
                                apiPath='shop/shops'
                                modelId={activeShop.id}
                                schemaPath='setting_live_chat_form_schema'
                            />
                        </CardBody>
                    </Card>
                </div>
    </AppWrapper>;
};

const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    firebaseTokenCancelTokenSource: state.Notifications.firebaseTokenCancelTokenSource,
    firebaseToken: state.Notifications.firebaseToken,
    firebaseTokenErrors: state.Notifications.firebaseTokenErrors,
});

const mapDispatchToProps = dispatch => ({
    revokeFirebaseToken: (firebaseToken, callbaack) => dispatch(revokeFirebaseToken(firebaseToken, callbaack)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveChat);
